"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLIDER_MOVING_CLASS = exports.SLIDER_VISIBLE_CLASS = exports.SLIDER_HIDDEN_CLASS = exports.SLIDER_ACTIVE_CLASS = exports.SLIDER_TOOLTIP = exports.SLIDER_DOUBLE_TRACK_FILL_CLASS = exports.SLIDER_DOUBLE_TRACK_CLASS = exports.SLIDER_DOUBLE_THUMB_RIGHT_CLASS = exports.SLIDER_DOUBLE_THUMB_LEFT_CLASS = exports.SLIDER_DOUBLE_INPUT_RIGHT_CLASS = exports.SLIDER_DOUBLE_INPUT_LEFT_CLASS = exports.SLIDER_SECONDARY_THUMBS_CONTAINER_CLASS = exports.SLIDER_SECONDARY_THUMB_CLASS = exports.SLIDER_TRACK_FILL_CLASS = exports.SLIDER_TRACK_CLASS = exports.SLIDER_THUMB_CLASS = exports.SLIDER_INPUT_CLASS = exports.SLIDER_N11 = exports.SLIDER_N5 = exports.SLIDER_ANIMATION_DURATION = exports.SLIDER_SIGNIFICANT_CHANGE = exports.SLIDER_N100 = exports.SLIDER_N52 = exports.SLIDER_N32 = exports.SLIDER_N24 = exports.SLIDER_N20 = exports.SLIDER_N12 = exports.SLIDER_N10 = exports.SLIDER_N4 = exports.SLIDER_N2 = exports.SLIDER_N1 = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var prefix = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-slider");
exports.SLIDER_N1 = 1;
exports.SLIDER_N2 = 2;
exports.SLIDER_N4 = 4;
exports.SLIDER_N10 = 10;
exports.SLIDER_N12 = 12;
exports.SLIDER_N20 = 20;
exports.SLIDER_N24 = 24;
exports.SLIDER_N32 = 32;
exports.SLIDER_N52 = 52;
exports.SLIDER_N100 = 100;
exports.SLIDER_SIGNIFICANT_CHANGE = 10;
exports.SLIDER_ANIMATION_DURATION = 250;
exports.SLIDER_N5 = 5;
exports.SLIDER_N11 = 11;
exports.SLIDER_INPUT_CLASS = "".concat(prefix, "-input");
exports.SLIDER_THUMB_CLASS = "".concat(prefix, "-thumb");
exports.SLIDER_TRACK_CLASS = "".concat(prefix, "-track");
exports.SLIDER_TRACK_FILL_CLASS = "".concat(prefix, "-track-fill");
exports.SLIDER_SECONDARY_THUMB_CLASS = "".concat(prefix, "-secondary-thumb");
exports.SLIDER_SECONDARY_THUMBS_CONTAINER_CLASS = "".concat(prefix, "-secondary-thumbs");
exports.SLIDER_DOUBLE_INPUT_LEFT_CLASS = "".concat(prefix, "-double-input-left");
exports.SLIDER_DOUBLE_INPUT_RIGHT_CLASS = "".concat(prefix, "-double-input-right");
exports.SLIDER_DOUBLE_THUMB_LEFT_CLASS = "".concat(prefix, "-double-thumb-left");
exports.SLIDER_DOUBLE_THUMB_RIGHT_CLASS = "".concat(prefix, "-double-thumb-right");
exports.SLIDER_DOUBLE_TRACK_CLASS = "".concat(prefix, "-double-track");
exports.SLIDER_DOUBLE_TRACK_FILL_CLASS = "".concat(prefix, "-double-track-fill");
exports.SLIDER_TOOLTIP = "".concat(prefix, "-tooltip");
exports.SLIDER_ACTIVE_CLASS = 'active';
exports.SLIDER_HIDDEN_CLASS = 'hidden';
exports.SLIDER_VISIBLE_CLASS = 'visible';
exports.SLIDER_MOVING_CLASS = 'moving';
